// import React, { useEffect, useState } from "react";
// import {
//   Typography,
//   Box,
//   Toolbar,
//   Container,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Snackbar,
//   IconButton,
//   CircularProgress,
//   MenuItem,
//   Select,
//   InputLabel,
//   FormControl,
//   Checkbox,
//   FormControlLabel,
// } from "@mui/material";
// import { Add, Edit, Delete } from "@mui/icons-material";
// import AdminSidebar from "../AdminSidebar";
// import Forbidden403 from "../components/common/Forbidden403";
// import { useAuth } from "../App";
// import { hasPermission } from "../utils/permissions";
// import { API_URL } from "../config";

// /**
//  * Questions admin page for listing, creating, editing, and deleting questions.
//  * Integrates with backend API using JWT authentication.
//  * Supports all question types and options as per backend schema.
//  */
// export default function Questions() {
//   const { auth, fetchWithAuth, isAuthenticated } = useAuth();
//   const hasListPermission = hasPermission(auth?.user, "question.list");
//   if (!hasListPermission) {
//     return (
//       <Box sx={{ display: 'flex', minHeight: '100vh', background: '#f7f7fa' }}>
//         <AdminSidebar selected="Questions" />
//         <Box sx={{ flex: 1, p: 3, mt: 7, mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//           <Forbidden403 message="You are not authorized to perform this action. Please contact your system administrator." />
//         </Box>
//       </Box>
//     );
//   }
//   const [questions, setQuestions] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [openDialog, setOpenDialog] = useState(false);
//   const [dialogMode, setDialogMode] = useState("create"); // 'create' | 'edit'
//   const [selectedQuestion, setSelectedQuestion] = useState(null);
//   const [text, setText] = useState("");
//   const [type, setType] = useState("text");
//   const [isRequired, setIsRequired] = useState(false);
//   const [order, setOrder] = useState(0);
//   const [choices, setChoices] = useState("");
//   const [isDefault, setIsDefault] = useState(false);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "success",
//   });
//   const [deleteDialog, setDeleteDialog] = useState({
//     open: false,
//     question: null,
//   });
//   const [description, setDescription] = useState("");

//   // Use fetchWithAuth and isAuthenticated from context
  

//   /** Fetch questions from backend API */
//   const fetchQuestions = async () => {
//     setLoading(true);
//     setError("");
//     try {
//       // if (!fetchWithAuth) throw new Error('Not authenticated');
//       const res = await fetchWithAuth(`${API_URL}/questions/`);
//       if (!res.ok) {
//         if (res.status === 403) {
//           setError(
//             "You are not authorized to perform this action. Please contact your system administrator."
//           );
//           return;
//         }
//         throw new Error("Failed to fetch questions");
//       }
//       const data = await res.json();
//       setQuestions(data);
//     } catch (err) {
//       setError(err.message || "Error fetching questions");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchQuestions();
//     // eslint-disable-next-line
//   }, []);

//   /** Open dialog for creating or editing */
//   const handleOpenDialog = (mode, question = null) => {
//     setDialogMode(mode);
//     setSelectedQuestion(question);
//     setText(question ? question.text : "");
//     setType(question ? question.type : "text");
//     setIsRequired(question ? question.is_required : false);
//     setOrder(question ? question.order : 0);
//     setChoices(question && question.choices ? question.choices.join(", ") : "");
//     setIsDefault(question ? question.is_default : false);
//     setDescription(question ? question.description || "" : "");
//     setOpenDialog(true);
//   };

//   /** Close dialog and reset state */
//   const handleCloseDialog = () => {
//     setOpenDialog(false);
//     setSelectedQuestion(null);
//     setText("");
//     setType("text");
//     setIsRequired(false);
//     setOrder(0);
//     setChoices("");
//     setIsDefault(false);
//     setDescription("");
//   };

//   /** Handle create or update question */
//   const handleSaveQuestion = async () => {
//     if (!text.trim()) {
//       setSnackbar({
//         open: true,
//         message: "Question text is required",
//         severity: "error",
//       });
//       return;
//     }
//     try {
//       setLoading(true);
//       const body = {
//         text,
//         description: description || undefined,
//         type,
//         is_required: isRequired,
//         order: Number(order),
//         is_default: isDefault,
//         choices:
//           type === "select"
//             ? choices
//                 .split(",")
//                 .map((c) => c.trim())
//                 .filter(Boolean)
//             : undefined,
//       };
//       let res;
//       if (dialogMode === "create") {
//         res = await fetchWithAuth(`${API_URL}/questions/`, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(body),
//         });
//       } else {
//         res = await fetchWithAuth(
//           `${API_URL}/questions/${selectedQuestion.id}`,
//           {
//             method: "PUT",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify(body),
//           }
//         );
//       }
//       if (!res.ok) {
//         if (res.status === 403) {
//           setError(
//             "You are not authorized to perform this action. Please contact your system administrator."
//           );
//           return;
//         }
//         throw new Error(
//           res.status === 400
//             ? "Failed to save question"
//             : "Failed to update question"
//         );
//       }
//       setSnackbar({
//         open: true,
//         message:
//           dialogMode === "create" ? "Question created" : "Question updated",
//         severity: "success",
//       });
//       handleCloseDialog();
//       fetchQuestions();
//     } catch (err) {
//       setSnackbar({
//         open: true,
//         message: err.message || "Error saving question",
//         severity: "error",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   /** Open delete confirmation dialog */
//   const handleOpenDelete = (question) => {
//     setDeleteDialog({ open: true, question });
//   };

//   /** Close delete confirmation dialog */
//   const handleCloseDelete = () => {
//     setDeleteDialog({ open: false, question: null });
//   };

//   /** Handle delete question */
//   const handleDeleteQuestion = async () => {
//     try {
//       setLoading(true);
//       const res = await fetchWithAuth(
//         `${API_URL}/questions/${deleteDialog.question.id}`,
//         {
//           method: "DELETE",
//         }
//       );
//       if (!res.ok) {
//         if (res.status === 403) {
//           setError(
//             "You are not authorized to perform this action. Please contact your system administrator."
//           );
//           return;
//         }
//         throw new Error("Failed to delete question");
//       }
//       setSnackbar({
//         open: true,
//         message: "Question deleted",
//         severity: "success",
//       });
//       handleCloseDelete();
//       fetchQuestions();
//     } catch (err) {
//       setSnackbar({
//         open: true,
//         message: err.message || "Error deleting question",
//         severity: "error",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box sx={{ display: "flex" }}>
//       <AdminSidebar selected="Questions" />
//       <Box component="main" sx={{ flexGrow: 1, pl: 3, pr: 2, pt: 2 }}>
//         <Toolbar />
//         <Container
//           maxWidth="md"
//           sx={{ py: { xs: 2, sm: 4 }, px: { xs: 1, sm: 3 } }}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               mb: 2,
//             }}
//           >
//             <Typography variant="h5" sx={{ fontWeight: 700 }}>
//               Questions
//             </Typography>
//             <Button
//               variant="contained"
//               startIcon={<Add />}
//               onClick={() => handleOpenDialog("create")}
//             >
//               Add Question
//             </Button>
//           </Box>
//           {loading ? (
//             <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
//               <CircularProgress />
//             </Box>
//           ) : error ? (
//             <Typography color="error">{error}</Typography>
//           ) : (
//             <TableContainer component={Paper} sx={{ mt: 1 }}>
//               <Table size="small">
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>Text</TableCell>
//                     <TableCell>Description</TableCell>
//                     <TableCell>Type</TableCell>
//                     <TableCell>Required</TableCell>
//                     <TableCell>Order</TableCell>
//                     <TableCell>Choices</TableCell>
//                     <TableCell align="right">Actions</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {questions.map((q) => (
//                     <TableRow key={q.id}>
//                       <TableCell>{q.text}</TableCell>
//                       <TableCell>
//                         {q.description || (
//                           <span style={{ color: "#888" }}>
//                             <em>No description</em>
//                           </span>
//                         )}
//                       </TableCell>
//                       <TableCell>{q.type}</TableCell>
//                       <TableCell>{q.is_required ? "Yes" : "No"}</TableCell>
//                       <TableCell>{q.order}</TableCell>
//                       <TableCell>
//                         {q.choices ? q.choices.join(", ") : "-"}
//                       </TableCell>
//                       <TableCell align="right">
//                         <IconButton
//                           size="small"
//                           onClick={() => handleOpenDialog("edit", q)}
//                           aria-label="edit"
//                         >
//                           <Edit fontSize="small" />
//                         </IconButton>
//                         <IconButton
//                           size="small"
//                           onClick={() => handleOpenDelete(q)}
//                           aria-label="delete"
//                           color="error"
//                         >
//                           <Delete fontSize="small" />
//                         </IconButton>
//                       </TableCell>
//                     </TableRow>
//                   ))}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//           )}
//         </Container>
//         {/* Create/Edit Dialog */}
//         <Dialog
//           open={openDialog}
//           onClose={handleCloseDialog}
//           fullWidth
//           maxWidth="sm"
//         >
//           <DialogTitle>
//             {dialogMode === "create" ? "Add Question" : "Edit Question"}
//           </DialogTitle>
//           <DialogContent>
//             <TextField
//               autoFocus
//               margin="dense"
//               label="Question Text"
//               type="text"
//               fullWidth
//               value={text}
//               onChange={(e) => setText(e.target.value)}
//               disabled={loading}
//             />
//             <TextField
//               margin="dense"
//               label="Description (optional)"
//               type="text"
//               fullWidth
//               value={description}
//               onChange={(e) => setDescription(e.target.value)}
//               disabled={loading}
//               sx={{ mt: 2 }}
//             />
//             <FormControl fullWidth margin="dense" sx={{ mt: 2 }}>
//               <InputLabel id="type-label">Type</InputLabel>
//               <Select
//                 labelId="type-label"
//                 value={type}
//                 label="Type"
//                 onChange={(e) => setType(e.target.value)}
//                 disabled={loading}
//               >
//                 <MenuItem value="text">Text</MenuItem>
//                 <MenuItem value="number">Number</MenuItem>
//                 <MenuItem value="boolean">Boolean</MenuItem>
//                 <MenuItem value="file">File</MenuItem>
//                 <MenuItem value="select">Select</MenuItem>
//               </Select>
//             </FormControl>
//             {type === "select" && (
//               <TextField
//                 margin="dense"
//                 label="Choices (comma separated)"
//                 type="text"
//                 fullWidth
//                 value={choices}
//                 onChange={(e) => setChoices(e.target.value)}
//                 disabled={loading}
//                 sx={{ mt: 2 }}
//               />
//             )}
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={isRequired}
//                   onChange={(e) => setIsRequired(e.target.checked)}
//                   disabled={loading}
//                 />
//               }
//               label="Required"
//               sx={{ mt: 2 }}
//             />
//             <TextField
//               margin="dense"
//               label="Order"
//               type="number"
//               fullWidth
//               value={order}
//               onChange={(e) => setOrder(e.target.value)}
//               disabled={loading}
//               sx={{ mt: 2 }}
//             />
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={isDefault}
//                   onChange={(e) => setIsDefault(e.target.checked)}
//                   disabled={loading}
//                 />
//               }
//               label="Default Question"
//               sx={{ mt: 2 }}
//             />
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleCloseDialog} disabled={loading}>
//               Cancel
//             </Button>
//             <Button
//               onClick={handleSaveQuestion}
//               variant="contained"
//               disabled={loading}
//             >
//               {dialogMode === "create" ? "Create" : "Update"}
//             </Button>
//           </DialogActions>
//         </Dialog>
//         {/* Delete Confirmation Dialog */}
//         <Dialog open={deleteDialog.open} onClose={handleCloseDelete}>
//           <DialogTitle>Delete Question</DialogTitle>
//           <DialogContent>
//             <Typography>
//               Are you sure you want to delete this question?
//             </Typography>
//           </DialogContent>
//           <DialogActions>
//             <Button onClick={handleCloseDelete} disabled={loading}>
//               Cancel
//             </Button>
//             <Button
//               onClick={handleDeleteQuestion}
//               color="error"
//               variant="contained"
//               disabled={loading}
//             >
//               Delete
//             </Button>
//           </DialogActions>
//         </Dialog>
//         {/* Snackbar for notifications */}
//         <Snackbar
//           open={snackbar.open}
//           autoHideDuration={4000}
//           onClose={() => setSnackbar({ ...snackbar, open: false })}
//           message={snackbar.message}
//           anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//         />
//       </Box>
//     </Box>
//   );
// }


import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Toolbar,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Snackbar,
  IconButton,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Checkbox,
  FormControlLabel,
  Alert,
  Chip,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import { Add, Edit, Delete } from "@mui/icons-material";
import AdminSidebar from "../AdminSidebar";
import Forbidden403 from "../components/common/Forbidden403";
import { useAuth } from "../App";
import { hasPermission } from "../utils/permissions";
import { API_URL } from "../config";

function SectionEyebrow({ children, color }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1.25,
        color,
        fontFamily: '"DM Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: "10.5px",
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        fontWeight: 500,
      }}
    >
      <Box
        sx={{
          width: 24,
          height: 2,
          borderRadius: 2,
          bgcolor: "currentColor",
          flexShrink: 0,
        }}
      />
      {children}
    </Box>
  );
}

/**
 * Questions admin page for listing, creating, editing, and deleting questions.
 * Integrates with backend API using JWT authentication.
 * Supports all question types and options as per backend schema.
 */
export default function Questions() {
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";

  const accent = dark ? "#fb923c" : "#f97316";
  const pageBg = dark ? "#07080f" : "#ffffff";
  const panelBg = dark ? "#0d1220" : "#ffffff";
  const text = dark ? "#e8f0fe" : "#0f0f1a";
  const mid = dark ? "#94a3b8" : "#4b4b6a";
  const muted = dark ? "#4b6080" : "#9898b8";
  const border = dark ? "rgba(99, 179, 237, 0.10)" : "#e8e8f0";

  const { auth, fetchWithAuth } = useAuth();
  const hasListPermission = hasPermission(auth?.user, "question.list");

  if (!hasListPermission) {
    return (
      <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: pageBg }}>
        <AdminSidebar selected="Questions" />
        <Box
          sx={{
            flex: 1,
            p: 3,
            mt: 7,
            mb: 3,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Forbidden403 message="You are not authorized to perform this action. Please contact your system administrator." />
        </Box>
      </Box>
    );
  }

  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMode, setDialogMode] = useState("create");
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [textValue, setTextValue] = useState("");
  const [type, setType] = useState("text");
  const [isRequired, setIsRequired] = useState(false);
  const [order, setOrder] = useState(0);
  const [choices, setChoices] = useState("");
  const [isDefault, setIsDefault] = useState(false);
  const [description, setDescription] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    question: null,
  });

  const fetchQuestions = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetchWithAuth(`${API_URL}/questions/`);
      if (!res.ok) {
        if (res.status === 403) {
          setError(
            "You are not authorized to perform this action. Please contact your system administrator."
          );
          return;
        }
        throw new Error("Failed to fetch questions");
      }
      const data = await res.json();
      setQuestions(data);
    } catch (err) {
      setError(err.message || "Error fetching questions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQuestions();
  }, []);

  const handleOpenDialog = (mode, question = null) => {
    setDialogMode(mode);
    setSelectedQuestion(question);
    setTextValue(question ? question.text : "");
    setType(question ? question.type : "text");
    setIsRequired(question ? question.is_required : false);
    setOrder(question ? question.order : 0);
    setChoices(question && question.choices ? question.choices.join(", ") : "");
    setIsDefault(question ? question.is_default : false);
    setDescription(question ? question.description || "" : "");
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedQuestion(null);
    setTextValue("");
    setType("text");
    setIsRequired(false);
    setOrder(0);
    setChoices("");
    setIsDefault(false);
    setDescription("");
  };

  const handleSaveQuestion = async () => {
    if (!textValue.trim()) {
      setSnackbar({
        open: true,
        message: "Question text is required",
        severity: "error",
      });
      return;
    }

    try {
      setLoading(true);
      const body = {
        text: textValue,
        description: description || undefined,
        type,
        is_required: isRequired,
        order: Number(order),
        is_default: isDefault,
        choices:
          type === "select"
            ? choices
                .split(",")
                .map((c) => c.trim())
                .filter(Boolean)
            : undefined,
      };

      let res;
      if (dialogMode === "create") {
        res = await fetchWithAuth(`${API_URL}/questions/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        });
      } else {
        res = await fetchWithAuth(`${API_URL}/questions/${selectedQuestion.id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        });
      }

      if (!res.ok) {
        if (res.status === 403) {
          setError(
            "You are not authorized to perform this action. Please contact your system administrator."
          );
          return;
        }
        throw new Error(
          res.status === 400
            ? "Failed to save question"
            : "Failed to update question"
        );
      }

      setSnackbar({
        open: true,
        message: dialogMode === "create" ? "Question created" : "Question updated",
        severity: "success",
      });

      handleCloseDialog();
      fetchQuestions();
    } catch (err) {
      setSnackbar({
        open: true,
        message: err.message || "Error saving question",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDelete = (question) => {
    setDeleteDialog({ open: true, question });
  };

  const handleCloseDelete = () => {
    setDeleteDialog({ open: false, question: null });
  };

  const handleDeleteQuestion = async () => {
    try {
      setLoading(true);
      const res = await fetchWithAuth(
        `${API_URL}/questions/${deleteDialog.question.id}`,
        {
          method: "DELETE",
        }
      );

      if (!res.ok) {
        if (res.status === 403) {
          setError(
            "You are not authorized to perform this action. Please contact your system administrator."
          );
          return;
        }
        throw new Error("Failed to delete question");
      }

      setSnackbar({
        open: true,
        message: "Question deleted",
        severity: "success",
      });

      handleCloseDelete();
      fetchQuestions();
    } catch (err) {
      setSnackbar({
        open: true,
        message: err.message || "Error deleting question",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: pageBg }}>
      <AdminSidebar selected="Questions" />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pl: { xs: 1.5, md: 3 },
          pr: { xs: 1.5, md: 3 },
          pt: 2,
          pb: 3,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Toolbar />

        <Container maxWidth="xl" disableGutters sx={{ mt: 1 }}>
          <Box
            sx={{
              mb: 3,
              overflow: "hidden",
              borderRadius: "28px",
              border: `1px solid ${border}`,
              background: dark
                ? `linear-gradient(135deg, ${alpha(accent, 0.14)} 0%, rgba(7,8,15,0.96) 45%, rgba(7,8,15,0.98) 100%)`
                : `linear-gradient(135deg, ${alpha(accent, 0.14)} 0%, rgba(255,255,255,0.98) 42%, rgba(248,248,251,0.98) 100%)`,
              boxShadow: dark
                ? "0 32px 80px rgba(0,0,0,0.30)"
                : "0 32px 80px rgba(15,15,26,0.08)",
            }}
          >
            <Box
              sx={{
                p: { xs: 3, sm: 4, md: 5 },
                display: "flex",
                alignItems: { xs: "flex-start", sm: "center" },
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 1.5,
              }}
            >
              <Box>
                <SectionEyebrow color={accent}>AjiraHQ · Questions</SectionEyebrow>
                <Typography
                  sx={{
                    mt: 2,
                    color: text,
                    fontWeight: 800,
                    fontSize: "clamp(30px, 4vw, 44px)",
                    lineHeight: 1.06,
                    letterSpacing: "-0.03em",
                    mb: 0.75,
                  }}
                >
                  Manage screening questions.
                </Typography>
                <Typography
                  sx={{
                    color: mid,
                    fontSize: "15px",
                    lineHeight: 1.8,
                    maxWidth: 620,
                  }}
                >
                  Create and maintain question items, response types, defaults,
                  and ordering.
                </Typography>
              </Box>

              <Button
                variant="contained"
                startIcon={<Add />}
                onClick={() => handleOpenDialog("create")}
                sx={{
                  textTransform: "none",
                  fontWeight: 700,
                  borderRadius: "12px",
                  px: 2.5,
                  py: 1.1,
                  background: accent,
                  boxShadow: `0 14px 34px ${alpha(accent, 0.22)}`,
                  "&:hover": {
                    background: accent,
                    filter: "brightness(1.08)",
                  },
                }}
              >
                Add Question
              </Button>
            </Box>
          </Box>

          <Paper
            elevation={0}
            sx={{
              p: 2.5,
              borderRadius: "22px",
              background: panelBg,
              border: `1px solid ${border}`,
              boxShadow: dark
                ? "0 20px 50px rgba(0,0,0,0.20)"
                : "0 12px 30px rgba(15,23,42,0.06)",
            }}
          >
            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: 260,
                }}
              >
                <CircularProgress sx={{ color: accent }} />
              </Box>
            ) : error ? (
              <Alert severity="error" sx={{ borderRadius: "18px" }}>
                {error}
              </Alert>
            ) : (
              <TableContainer
                sx={{
                  borderRadius: "18px",
                  border: `1px solid ${border}`,
                  overflowX: "auto",
                }}
              >
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      {["Text", "Description", "Type", "Required", "Order", "Choices", "Actions"].map(
                        (header) => (
                          <TableCell
                            key={header}
                            sx={{
                              fontWeight: 700,
                              color: mid,
                              background: dark ? "#111827" : "#fafafa",
                              borderBottom: `1px solid ${border}`,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {header}
                          </TableCell>
                        )
                      )}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {questions.map((q) => (
                      <TableRow
                        key={q.id}
                        hover
                        sx={{
                          "& td": {
                            borderBottom: `1px solid ${border}`,
                            background: dark ? "rgba(13,18,32,0.96)" : "#ffffff",
                            color: mid,
                            verticalAlign: "top",
                          },
                          "&:hover td": {
                            background: dark
                              ? "rgba(255,255,255,0.03)"
                              : "rgba(15,15,26,0.02)",
                          },
                        }}
                      >
                        <TableCell sx={{ color: text, fontWeight: 700, minWidth: 200 }}>
                          {q.text}
                        </TableCell>

                        <TableCell sx={{ minWidth: 220 }}>
                          {q.description || (
                            <Typography sx={{ color: muted, fontStyle: "italic", fontSize: "13px" }}>
                              No description
                            </Typography>
                          )}
                        </TableCell>

                        <TableCell>
                          <Chip
                            label={q.type}
                            size="small"
                            sx={{
                              borderRadius: 999,
                              fontWeight: 700,
                              textTransform: "capitalize",
                              background: dark
                                ? "rgba(255,255,255,0.04)"
                                : "rgba(15,15,26,0.03)",
                              color: mid,
                              border: `1px solid ${border}`,
                            }}
                          />
                        </TableCell>

                        <TableCell>
                          <Chip
                            label={q.is_required ? "Yes" : "No"}
                            size="small"
                            sx={{
                              borderRadius: 999,
                              fontWeight: 700,
                              background: q.is_required
                                ? dark
                                  ? "rgba(34,197,94,0.18)"
                                  : "rgba(34,197,94,0.10)"
                                : dark
                                ? "rgba(148,163,184,0.16)"
                                : "rgba(148,163,184,0.12)",
                              color: q.is_required
                                ? dark
                                  ? "#86efac"
                                  : "#15803d"
                                : dark
                                ? "#cbd5e1"
                                : "#374151",
                              border: `1px solid ${
                                q.is_required
                                  ? dark
                                    ? "rgba(34,197,94,0.24)"
                                    : "rgba(34,197,94,0.18)"
                                  : dark
                                  ? "rgba(148,163,184,0.24)"
                                  : "rgba(148,163,184,0.18)"
                              }`,
                            }}
                          />
                        </TableCell>

                        <TableCell>{q.order}</TableCell>

                        <TableCell sx={{ minWidth: 200 }}>
                          {q.choices && q.choices.length > 0 ? (
                            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
                              {q.choices.map((choice, idx) => (
                                <Chip
                                  key={idx}
                                  label={choice}
                                  size="small"
                                  sx={{
                                    borderRadius: 999,
                                    background: dark
                                      ? alpha(accent, 0.14)
                                      : alpha(accent, 0.08),
                                    color: accent,
                                    border: `1px solid ${alpha(accent, 0.2)}`,
                                  }}
                                />
                              ))}
                            </Box>
                          ) : (
                            <Typography sx={{ color: muted, fontSize: "13px" }}>-</Typography>
                          )}
                        </TableCell>

                        <TableCell sx={{ whiteSpace: "nowrap" }} align="right">
                          <IconButton
                            size="small"
                            onClick={() => handleOpenDialog("edit", q)}
                            aria-label="edit"
                            sx={{ color: mid, mr: 0.5 }}
                          >
                            <Edit fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => handleOpenDelete(q)}
                            aria-label="delete"
                            sx={{ color: "#dc2626" }}
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}

                    {questions.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={7} align="center">
                          <Typography sx={{ py: 3, color: muted }}>
                            No questions found.
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Paper>
        </Container>

        <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="sm">
          <DialogTitle
            sx={{
              fontWeight: 800,
              color: text,
              letterSpacing: "-0.02em",
            }}
          >
            {dialogMode === "create" ? "Add Question" : "Edit Question"}
          </DialogTitle>

          <DialogContent dividers>
            <TextField
              autoFocus
              margin="dense"
              label="Question Text"
              type="text"
              fullWidth
              value={textValue}
              onChange={(e) => setTextValue(e.target.value)}
              disabled={loading}
            />

            <TextField
              margin="dense"
              label="Description (optional)"
              type="text"
              fullWidth
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              disabled={loading}
              sx={{ mt: 2 }}
            />

            <FormControl fullWidth margin="dense" sx={{ mt: 2 }}>
              <InputLabel id="type-label">Type</InputLabel>
              <Select
                labelId="type-label"
                value={type}
                label="Type"
                onChange={(e) => setType(e.target.value)}
                disabled={loading}
              >
                <MenuItem value="text">Text</MenuItem>
                <MenuItem value="number">Number</MenuItem>
                <MenuItem value="boolean">Boolean</MenuItem>
                <MenuItem value="file">File</MenuItem>
                <MenuItem value="select">Select</MenuItem>
              </Select>
            </FormControl>

            {type === "select" && (
              <TextField
                margin="dense"
                label="Choices (comma separated)"
                type="text"
                fullWidth
                value={choices}
                onChange={(e) => setChoices(e.target.value)}
                disabled={loading}
                sx={{ mt: 2 }}
              />
            )}

            <FormControlLabel
              control={
                <Checkbox
                  checked={isRequired}
                  onChange={(e) => setIsRequired(e.target.checked)}
                  disabled={loading}
                />
              }
              label="Required"
              sx={{ mt: 2 }}
            />

            <TextField
              margin="dense"
              label="Order"
              type="number"
              fullWidth
              value={order}
              onChange={(e) => setOrder(e.target.value)}
              disabled={loading}
              sx={{ mt: 2 }}
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={isDefault}
                  onChange={(e) => setIsDefault(e.target.checked)}
                  disabled={loading}
                />
              }
              label="Default Question"
              sx={{ mt: 2 }}
            />
          </DialogContent>

          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button onClick={handleCloseDialog} disabled={loading}>
              Cancel
            </Button>
            <Button
              onClick={handleSaveQuestion}
              variant="contained"
              disabled={loading}
            >
              {dialogMode === "create" ? "Create" : "Update"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={deleteDialog.open} onClose={handleCloseDelete}>
          <DialogTitle
            sx={{
              fontWeight: 800,
              color: text,
              letterSpacing: "-0.02em",
            }}
          >
            Delete Question
          </DialogTitle>

          <DialogContent dividers>
            <Typography sx={{ color: mid }}>
              Are you sure you want to delete this question?
            </Typography>
          </DialogContent>

          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button onClick={handleCloseDelete} disabled={loading}>
              Cancel
            </Button>
            <Button
              onClick={handleDeleteQuestion}
              color="error"
              variant="contained"
              disabled={loading}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={4000}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            severity={snackbar.severity}
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
}